// extracted by mini-css-extract-plugin
export default {"rating":"jz-z","numberOfStars":"kz-z","count":"lz-z","barGraphSpacing":"mz-z","barGraph":"nz-z"};